import PageHeader from 'components/common/PageHeader';
import Integracion from './components/Integracion';

const IntegracionPage = () => {
  return (
    <>
      <PageHeader
        title="Integraciones"
        description='En esta sección puede gestionar las claves que necesita para integrar aplicaciones externas. <br/> <a href="https://cabaprop.ar/api/v1/integration-docs" target="_blank">Link documentación</a>'
        className="mb-3 bg-white"
      />

      <Integracion />
    </>
  );
};

export default IntegracionPage;
